(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["team-grid-toggle"] && !Shopify.designMode) return;
  try {
    
(function() {
  var list = document.querySelector('.section-{{ section.id }} .team-grid__list');
  if (list) list.style.setProperty('--team-gap', '{{ section.settings.gap | default: 20 }}px');
})();

  } catch(e) { console.error(e); }
})();
})();
